import { PageDialog } from "@/components/dialog/PageDialog"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useAbsenceRequestsForYoung } from "@/entities/absenceRequest/useAbsenceRequest"
import { useAuth } from "@/hooks/useAuth"
import { AbsenceRequestContent } from "@/pages/AbsenceRequest"
import { useState } from "react"
import { Link } from "react-router-dom"

export default function AbsenceRequests() {
   const { user } = useAuth()
   const { data: absenceRequests, ...query } = useAbsenceRequestsForYoung({ youngId: user?.id })
   const [selectedRequestId, setSelectedRequestId] = useState<string | null>(null)

   return (
      <>
         <QueryRender query={query} data={absenceRequests}>
            {(absenceRequests) => (
               <div className="container mx-auto py-6">
                  <div className="bg-white shadow rounded-lg p-6">
                     <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold">Mes demandes d'absence</h1>
                        <Link to="/jeune/nouvelle-demande-absence" className="btn btn-primary">
                           <svg
                              className="w-6 h-6 mr-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                           </svg>
                           Nouvelle demande
                        </Link>
                     </div>

                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {absenceRequests.map((request) => (
                           <div
                              key={request.id}
                              className="card bg-base-100 shadow-md hover:shadow-lg cursor-pointer transition-shadow"
                              onClick={() => setSelectedRequestId(request.id)}
                           >
                              <div className="card-body p-4 md:p-8">
                                 <div className="flex flex-col gap-2">
                                    <AbsenceRequestContent id={request.id} variant="small" />
                                 </div>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            )}
         </QueryRender>
         <PageDialog isOpen={!!selectedRequestId} onClose={() => setSelectedRequestId(null)}>
            {selectedRequestId && <AbsenceRequestContent id={selectedRequestId} variant="full" />}
         </PageDialog>
      </>
   )
}
